export default "__VITE_ASSET__fP_s8EdR__"